import{createContext as r,useContext as t}from"react";const o=r({currentTab:""}),e=o.Provider;function n(){return t(o)}export{e as TabContextProvider,n as useTab};
